import { EventEmitter } from 'events';
import Schema from 'schema.io';
import OriginalPointsLoader from '../loaders/OriginalPointsLoader';

const originalPointsLoader = new OriginalPointsLoader();

const pointSchema = new Schema({
  lng: { type: Number, min: -180, max: 180 },
  lat: { type: Number, min: -90, max: 90 },
});

const ResultTypeEnumsV1 = ['固定解', '浮动解', '码差分', '单点', '广域', '无解'];
const ResultTypeEnumsV1English = ['FIXED', 'FLOAT', '码差分', 'SINGLE'];
const ResultTypeEnumsV2 = ['RTK固定解', 'RTK浮动解', '伪距', '单点定位', '广域差分', '无解'];

const parseOriginalLngLatToWGS84LngLat = (original: string, Language: string) => {
  if (/°/.test(original)) {
    const indexOfDegree = original.indexOf('°');
    const indexOfMinute = Language === 'English' ? original.indexOf('\′') : original.indexOf('\'');
    const indexOfSecond = Language === 'English' ? original.indexOf('\″') : original.indexOf('\"');
    const degrees = parseFloat(original.slice(0, indexOfDegree));
    const minutes = parseFloat(original.slice(indexOfDegree + 1, indexOfMinute));
    const seconds = parseFloat(original.slice(indexOfMinute + 1, indexOfSecond));
    return degrees + minutes / 60 + seconds / 3600;
  } else {
    const [degrees, minutes, seconds = 0] = original.slice(1, -1).split(':').map(parseFloat);
    return degrees + minutes / 60 + seconds / 3600;
  }
};

export default class CSVProcessor extends EventEmitter implements IFileProcessor {
  public process(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      const data = reader.result.split('\n').filter((row: string) => row.length > 0).map((row: string) => row.split(','));
      const keys = data.splice(0, 1)[0];
      if (!keys.includes('B') || !keys.includes('L') || !(keys.includes('解类型') || keys.includes('Solve Status'))) {
        this.emit('error', new Error('没有B或L列或解类型列'));
        return;
      }
      const BIndex = keys.indexOf('B');
      const LIndex = keys.indexOf('L');
      const chineseTypeIndex = keys.indexOf('解类型');
      const ResultTypeIndex = chineseTypeIndex === -1 ? keys.indexOf('Solve Status') : chineseTypeIndex;
      const language = chineseTypeIndex < 0 ? 'English' : 'Chinese';
      try {
        const points = data.map((row: string[], index: number) => {
          try {
            const point = pointSchema.validate({
              lng: parseOriginalLngLatToWGS84LngLat(row[LIndex], language),
              lat: parseOriginalLngLatToWGS84LngLat(row[BIndex], language),
            }) as { lng: number, lat: number };
            let resultType = ResultTypeEnumsV1.indexOf(row[ResultTypeIndex]);
            if (resultType < 0) {
              resultType = ResultTypeEnumsV1English.indexOf(row[ResultTypeIndex]);
              if (resultType < 0) {
                resultType = ResultTypeEnumsV2.indexOf(row[ResultTypeIndex]);
              }
            }
            return {
              lngLat: [point.lng, point.lat],
              properties: {
                resultType,
              },
            };
          } catch (error) {
            error.message = `第${index}行：${error.message}`;
            throw error;
          }
        });
        originalPointsLoader.addPoints(points);
      } catch (err) {
        this.emit('error', err);
        return;
      }
    };
    reader.readAsText(file, 'gb2312');
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/processors/CSVProcessor.ts